const PUBLIC_API_ORIGIN = "https://nex-astro-edge-worker.mlepagelaw.workers.dev";

export function apiUrl(path: string): string {
  if (typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")) {
    return path;
  }
  return `${PUBLIC_API_ORIGIN}${path}`;
}
